import { mapState } from 'vuex';
import appmenu from "@/components/modules/appmenu/index.vue";
import topmenu from "@/components/modules/appmenu/topmenu/index.vue";
import leftmenu from "@/components/modules/appmenu/leftmenu/index.vue";
import camera from "@/components/common/camera/index.vue";
import actual from "@/components/modules/notifications/actual/index.vue";
import fx from "@/components/assets/fx/index.vue";
import animatedBg from "@/components/assets/animatedBg/index.vue";


export default {
	name: 'root',
	props: {
	},

	data : function(){

		return {
			loading : false,
			blockTouch : false,
			isRouterAlive : true,
			refreshPosition : 0,
			dropfile : false,
			anim : false,
			
		}

	},
	components : {appmenu, camera, fx, actual, topmenu, animatedBg, leftmenu},
	created (){
		
	},

	watch: {
		summaryview : {
			immediate : true,
			handler : function(){
				window.requestAnimationFrame(() => {
					this.anim = this.summaryview
				})
			}
		}
	},
	computed: mapState({
		
		auth : state => state.auth,
		gallery : state => state.gallery,
		globalpreloader : state => state.globalpreloader,
		online : state => state.online,
		iconshow: function() {
			return this.$store.state.icon ? true : false
		},

		candrop : function(){
			return !this.camera && !this.globalpreloader && this.auth && !this.gallery
		},

		interfaceSettings : state => state.lssettings.interface || {},

		camera : state => state.camera,
		fx : state => state.fx,
		fx2fs: state => state.fx2fs,
		theight : state => state.theight,
		tscrolly : state => state.tscrolly,
		playingstory : state => state.playingstory,
		delayedAction : state => state.delayedAction,
		//summaryview : state => state.summaryview,

		summaryview : function(){
			return this.$route.name == 'summary'
		},

		wideview : function(){
			return this.$route.name == 'main'
		},

		removetopmenu : function(){
			return this.$route.name == 'story' || this.$route.name == 'authorization' || this.$route.name == 'signin' || this.$route.name == 'registration'
		},

		userefresher : function(){
			return this.$route.name == 'panel' || (this.$route.name && this.$route.name.indexOf('panel_') > -1) || this.$route.name == 'courses' || this.$route.name == 'course' || this.$route.name == 'profile' || this.$route.name == 'features'
		},

		directions : function(){

			var distance = 100

			return this.userefresher ? {
				bottom: {
					distance,
					direction: 'bottom',
	
					constraints : (e) => {
						return this.tscrolly == 0
					},

					clbk : (v, d) => {
						
						var p = v / distance

						this.refreshPosition = p * 100
					}
				}
			} : null
		},
		
	}),

	methods : {
		closeCamera : function(){
			this.$store.commit('CLOSE_CAMERA')
		},

		cancelDelayedAction : function(){
			this.$store.commit('delayedAction', null)
		},

		refresh : function(){
			this.isRouterAlive = false

			this.core.api.invalidateStorageAll()

			this.$nextTick(() => (this.isRouterAlive = true))

			/*this.core.api.checkUpdates()
			this.core.updates.synk()*/
		},


		closeGallery: function () {
            this.$store.commit('GALLERY', null)
        },
	},
}